<template>

    <div>

        <div id="top"></div>

        <div class="logo-wrapper" id="ovb-felso-sav" :class="getClass()">

            <img
                class="ovb-logo"
                src="../../assets/1.svg"
            >

            <div class="ovb-title">

                <p> GÉPJÁRMŰ </p>

                <p> BIZTOSÍTÁSOK </p>

            </div>

        </div>

        <v-app>

            <v-container id="container" fluid>

                <v-layout row justify-space-between>

                    <v-flex dm10 xs12>
                        <BnTabs color="primary" :pages="app.pages"/>

                        <router-view/>

                        <BnNavigationButtons
                            v-if="!loading"
                        />

                        <BnTabs color="primary" :pages="app.pages"/>

                        <div v-if="app.notifications">

                            <notifications
                                    position="bottom right"
                                    :class="{'notify-class': true, 'send-to-bg': !notificationsVisible}"
                                    group="notify"
                                    ref="vuenoti"
                            />

                        </div>

                        <BnHelp
                                :modozat="app.modozat"
                                :codename="app.help.codename"
                                :aktiv="true"
                                :help="app.help.help"
                        />

                        <BnConfirmDialog ref="confirm" />

                    </v-flex>

                </v-layout>

            </v-container>

            <span class="version"> {{ version }} </span>

        </v-app>

    </div>

</template>

<script>
import Vue from 'vue';
import AppConfig from '../../modules/AppConfig';
import { isDesktop } from '../../utils/WindowUtils';
import BnTabs from './BnTabs.vue';
import BnNavigationButtons from './BnNavigationButtons.vue';

export default {
    name: 'OvbApp',
    components: {BnNavigationButtons, BnTabs },
    data() {
        return {
            small: false,
            version: '',
            isMounted: false,
        };
    },

    computed: {
        getVersion() {
            return document.getElementById('version').value;
        },
        loading() {
            return this.$store.getters.isLoading;
        },
        notificationsVisible() {
            if (!this.isMounted) {
                return false;
            }
            return this.$refs?.vuenoti?.list?.length > 0;
        },
    },

    watch: {
        getVersion(version) {
            this.version = version;
        },
    },

    methods: {
        isDesktop,
        getClass() {
            return { smallHeader: this.small };
        },
    },
    mounted() {
        this.isMounted = true;
        Vue.mixin({
            methods: {
                confirm: this.$refs.confirm.openWithConfig,
            },
        });
        this.$nextTick(() => {
            if (document.getElementById('version')) {
                this.version = document.getElementById('version').value;
            }
        });
    },
    props: {
        app: {
            type: Object,
            default: new AppConfig().getConfig(),
        },
    },
};
</script>

<style>

    .row {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
        margin-right: -12px !important;
        margin-left: -12px !important;
    }
    body {
        background-color: #fafafa
    }

    .logo-wrapper {
        position: fixed;
        z-index: 200;
        top: -70px;
        /*-webkit-mask-image: -webkit-gradient( linear, left bottom, left top, color-stop(0.5, rgba(15,8,188,1)),
        color-stop(0.5, rgba(70,62,255,0.5)));
        mask-image: linear-gradient(to bottom, rgb(15, 8, 188) 50%, rgb(255, 204, 51) 50%);*/
        background-image: linear-gradient(to bottom, rgb(255, 255, 255) 50%, rgb(255, 204, 51) 50%);
        /*background-color: #FFCC33;*/
        width: 100%;
        height: 220px;
        transition: height 0.1s;
    }

    .ovb-logo {
        height: 100%;
        width: 100%;
        margin-left: 49%;
    }

    .ovb-title {
        width: fit-content;
        position: relative;
        top: -90px;
        color: #003366;
        font-weight: bold;
        margin-left: 18px;
        font-size: 24px !important;
        font-family: "Segoe UI", Arial, sans-serif !important;
        letter-spacing: 0.02em !important;
    }

    .notify-class {
        top: 170px !important;
        right: 12px !important;
        height: 150px !important;
    }
    .send-to-bg {
        z-index: -9999 !important;
    }
    .v-label--active {
        font-size: 18px;
        text-overflow: unset !important;
        max-width: 130% !important;
        /*height: 20px !important;
        line-height: 20px !important;*/
    }

    .v-tabs__div:has(.v-tabs__item--active) {
        /*width: 0;
        height: 0;
        border-top: 60px solid transparent !important;
        border-bottom: 60px solid transparent !important;
        border-left: 60px solid green !important;
        z-index: 999;*/
    }

    *:not(.v-icon):not(.fa) {
        /* font-family: 'Stag Sans LCG Web' !important;*/
    }

    .smallHeader {
        height: 150px !important;
        transition: height 0.1s;
    }

    .v-messages__message {
        min-height: 20px !important;
        margin-top: 2px !important;

    }

    #app {
        /*margin-left: 30%;*/
        /* margin-right: 25%;*/
        scroll-behavior: smooth;
        margin-top: 160px !important;
        max-width: 1000px;
        margin-left: auto;
        margin-right: auto;
        background: #fafafa;
    }

    @media only screen and (max-width: 750px) {
        #app {
            margin-right: 0;
        }

        .ovb-logo {
            right: -60px;
            top: -60px;
        }
    }

    .v-card__text {
        scroll-behavior: smooth;
    }

    /* @media only screen and (max-width: 1400px) {
         #app {
             margin-left: 17%;
             margin-right: 12%;
         }
         .ovb-logo {
             right: -60px;
         }
     }

     @media only screen and (max-width: 1000px) {
         #app {
             margin-left: 10%;
             margin-right: 10%;
         }
         .ovb-logo {
             right: -60px;
         }
     }

     @media only screen and (max-width: 500px) {
         #app {
             margin-left: 0;
             margin-right: 5%;
         }
         .ovb-logo {
             right: -60px;
         }
     }*/

    .reveal-modal {
        height: 50px !important;
    }

    .item-row {
        padding-top: 5px;
        padding-bottom: 5px;
    }

    .item-row:hover {
        background-color: #1976d2;
        color: white;
    }

    .item-row:hover > .v-icon {
        color: white;
    }

    .item-row:hover .v-icon {
        color: white;
    }

    @font-face {
        font-family: 'Stag Sans LCG Web';
        src: url("../../../fonts/StagSans-MediumItalic-Cy-Gr-Web.eot");
        src: url("../../../fonts/StagSans-MediumItalic-Cy-Gr-Web.eot?#iefix") format("embedded-opentype"),
        url("../../../fonts/StagSans-MediumItalic-Cy-Gr-Web.woff2") format("woff2"),
        url("../../../fonts/StagSans-MediumItalic-Cy-Gr-Web.woff") format("woff");
        font-weight: 500;
        font-style: italic;
        font-stretch: normal
    }

    @font-face {
        font-family: 'Stag Sans LCG Web';
        src: url("../../../fonts/StagSans-Medium-Cy-Gr-Web.eot");
        src: url("../../../fonts/StagSans-Medium-Cy-Gr-Web.eot?#iefix") format("embedded-opentype"),
        url("../../../fonts/StagSans-Medium-Cy-Gr-Web.woff2") format("woff2"),
        url("../../../fonts/StagSans-Medium-Cy-Gr-Web.woff") format("woff");
        font-weight: 500;
        font-style: normal;
        font-stretch: normal
    }

    @font-face {
        font-family: 'Stag Sans LCG Web';
        src: url("../../../fonts/StagSans-BookItalic-Cy-Gr-Web.eot");
        src: url("../../../fonts/StagSans-BookItalic-Cy-Gr-Web.eot?#iefix") format("embedded-opentype"),
        url("../../../fonts/StagSans-BookItalic-Cy-Gr-Web.woff2") format("woff2"),
        url("../../../fonts/StagSans-BookItalic-Cy-Gr-Web.woff") format("woff");
        font-weight: 400;
        font-style: italic;
        font-stretch: normal
    }

    @font-face {
        font-family: 'Stag Sans LCG Web';
        src: url("../../../fonts/StagSans-Book-Cy-Gr-Web.eot");
        src: url("../../../fonts/StagSans-Book-Cy-Gr-Web.eot?#iefix") format("embedded-opentype"),
        url("../../../fonts/StagSans-Book-Cy-Gr-Web.woff2") format("woff2"),
        url("../../../fonts/StagSans-Book-Cy-Gr-Web.woff") format("woff");
        font-weight: 400;
        font-style: normal;
        font-stretch: normal
    }

    .version {
        font-size: 12px;
        color: #4e4e4e;
        float: right;
        margin: 15px;
    }

    @font-face {
      font-family: 'SegoeUI';
      src:
          local("Segoe UI Light"),
          url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/light/latest.woff2) format("woff2"),
          url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/light/latest.woff) format("woff"),
          url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/light/latest.ttf) format("truetype");
      font-weight: 100;
    }

    @font-face {
      font-family: 'SegoeUI';
      src:
          local("Segoe UI Semilight"),
          url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/semilight/latest.woff2) format("woff2"),
          url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/semilight/latest.woff) format("woff"),
          url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/semilight/latest.ttf) format("truetype");
      font-weight: 200;
    }

    @font-face {
      font-family: 'SegoeUI';
      src:
          local("Segoe UI"),
          url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/normal/latest.woff2) format("woff2"),
          url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/normal/latest.woff) format("woff"),
          url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/normal/latest.ttf) format("truetype");
      font-weight: 400;
    }

    @font-face {
      font-family: 'SegoeUI';
      src:
          local("Segoe UI Semibold"),
          url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/semibold/latest.woff2) format("woff2"),
          url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/semibold/latest.woff) format("woff"),
          url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/semibold/latest.ttf) format("truetype");
      font-weight: 600;
    }

    @font-face {
      font-family: 'SegoeUI';
      src:
          local("Segoe UI Bold"),
          url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/bold/latest.woff2) format("woff2"),
          url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/bold/latest.woff) format("woff"),
          url(https://c.s-microsoft.com/static/fonts/segoe-ui/west-european/bold/latest.ttf) format("truetype");
      font-weight: 700;
    }

    .v-application,
    .v-application p:not(.v-icon, .mdi),
    .v-application span:not(.v-icon, .mdi),
    .v-application div:not(.v-icon, .mdi),
    .v-application button:not(.v-icon, .mdi),
    .v-application input:not(.v-icon, .mdi),
    .v-application textarea:not(.v-icon, .mdi) {
      font-family: "Segoe UI", Arial, sans-serif !important;
      /* Betűköz legalább 0.12-szeres */
      letter-spacing: 0.12em !important;
      /* Szóköz legalább 0.16-szoros */
      word-spacing: 0.16em !important;
    }
    .v-application p:not(.v-icon, .mdi) {
      margin-bottom: 2em !important;
    }
    .forgalmi-prefix {
      color: var(--v-tileColor-base) !important;
    }
</style>
